/**
 * WHERE "THEIR MAIN SITE" IS, FROM THE DESK'S OWN HOST.
 *
 * The sign-in footer links a shop's desk back to its public site. Every
 * shop so far was shop.<theirs>.com, so stripping "shop." was the whole
 * rule. WeRV's desk is wervshop.clickflame.com and its site is
 * werv.clickflame.com, and the old rule linked the desk to itself. So a
 * first label that ENDS in "shop" loses that too ("werv-shop" as well).
 * Anything else comes back unchanged.
 *
 * Pure, because the failure it prevents is a link that works and goes
 * nowhere new, which nobody reports.
 */
export function mainSiteOf(domain: string | null | undefined): string {
  const d = String(domain ?? "").trim().toLowerCase();
  if (d.startsWith("shop.")) return d.slice(5);
  const [first, ...rest] = d.split(".");
  if (first && rest.length > 1 && first.length > 4 && first.endsWith("shop")) {
    return [first.slice(0, -4).replace(/-$/, ""), ...rest].join(".");
  }
  return d;
}
